export default "<div class=\"p-4\">\n  <kr-wallet-block class=\"mb-4\"></kr-wallet-block>\n  <kr-quota-history></kr-quota-history>\n</div>";